import React from 'react';

const NodeFormSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.375 13.125V0.875H5.6875C5.92944 0.875 6.125 0.679 6.125 0.4375C6.125 0.196 5.92944 0 5.6875 0H2.1875C1.94556 0 1.75 0.196 1.75 0.4375C1.75 0.679 1.94556 0.875 2.1875 0.875H3.5V13.125H2.1875C1.94556 13.125 1.75 13.321 1.75 13.5625C1.75 13.804 1.94556 14 2.1875 14H5.6875C5.92944 14 6.125 13.804 6.125 13.5625C6.125 13.321 5.92944 13.125 5.6875 13.125H4.375ZM2.1875 1.75C2.42944 1.75 2.625 1.946 2.625 2.1875C2.625 2.429 2.42944 2.625 2.1875 2.625H0.875V11.375H2.1875C2.42944 11.375 2.625 11.571 2.625 11.8125C2.625 12.054 2.42944 12.25 2.1875 12.25H0.875C0.392 12.25 0 11.858 0 11.375V2.625C0 2.142 0.392 1.75 0.875 1.75H2.1875ZM14 2.625C14 2.142 13.608 1.75 13.125 1.75H5.6875C5.44556 1.75 5.25 1.946 5.25 2.1875C5.25 2.429 5.44556 2.625 5.6875 2.625H13.125V11.375H5.6875C5.44556 11.375 5.25 11.571 5.25 11.8125C5.25 12.054 5.44556 12.25 5.6875 12.25H13.125C13.608 12.25 14 11.858 14 11.375V2.625Z"
        fill={color}
      />
    </svg>
  );
};

export default NodeFormSVG;
